import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { IEmailType } from '../shared/models/interfaces/email-type';
import { Urls } from "../shared/Urls";
import { OperatorHelpers } from "../shared/helpers/operator.helpers";
import { map } from 'rxjs/operators';
import { IEmailTemplate } from "../shared/models/interfaces/email-template";

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  constructor(private http: HttpClient) {
  }

  getEmailTypes(): Observable<IEmailType[]> {
    return this.http
      .get(`${Urls.getAllEmailTypes}`)
      .pipe(
        map(responseData => {
          const data: IEmailType[] = [];

          return OperatorHelpers.mapToList(responseData, data);
        })
      );
  }

  getEmailTemplateByEmailTypeId(emailTypeId: number): Observable<IEmailTemplate> {
    return this.http
      .get(`${Urls.getEmailTemplateByEmailTypeId(emailTypeId)}`)
      .pipe(
        map(responseData => {
          return responseData as IEmailTemplate;
        })
      );
  }

  createEmailTemplate(emailTemplate: IEmailTemplate): Observable<IEmailTemplate> {
    return this.http.post(Urls.createEmailTemplate, emailTemplate)
      .pipe(
        map((responseData) => {
          return responseData as IEmailTemplate;
        })
      );
  }

  update(emailTemplate: IEmailTemplate): Observable<IEmailTemplate> {
    return this.http.put(Urls.updateEmailTemplate, emailTemplate)
      .pipe(
        map((responseData) => {
          return responseData as IEmailTemplate;
        })
      );
  }
}
